import {
  RosterRequestDataNewReservation,
  RosterRequestQuery,
  RosterRequestType,
} from 'generated/graphql';

import NewGroupReservationRequest from '../NewGroupReservationRequest';

import RequestedChanges from './DateChange/RequestedChanges';
import NewReservationsList from './NewReservation/NewReservationsList';
import PreferredHotel from './NewReservation/PreferredHotel';

type RequestDataProps = {
  request: RosterRequestQuery['rosterRequest'];
};

const RequestData = ({ request }: RequestDataProps) => {
  if (!request?.requestData) {
    return null;
  }

  switch (request.requestType) {
    case RosterRequestType.NewReservation:
      return (
        <>
          <PreferredHotel
            requestData={request.requestData as RosterRequestDataNewReservation}
          />
          <div className="mt-10">
            <NewReservationsList
              controlNumber={request.controlNumber ?? undefined}
              requestData={
                request.requestData as RosterRequestDataNewReservation
              }
              clientId={request.client.id}
              id={request.id}
            />
          </div>
        </>
      );
    case RosterRequestType.DateChange:
      return <RequestedChanges request={request} />;
    case RosterRequestType.NewGroupReservation:
      // So the types seems to be a bit incomplete,
      // It should be a full union with requestData and request
      // type. This is a workaround until we have a refactor.
      if (
        request.requestData.__typename ===
        'RosterRequestDataNewGroupReservation'
      ) {
        const { groupCheckInDate, groupCheckOutDate, ...data } =
          request.requestData;

        return (
          <NewGroupReservationRequest
            requestStatus={request.status}
            id={request.id}
            request={request}
            requestData={{
              ...data,
              checkInDate: groupCheckInDate,
              checkOutDate: groupCheckOutDate,
            }}
          />
        );
      } else {
        throw 'This should never happen';
      }
    default:
      return null;
  }
};

export default RequestData;
